import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  items: {},
});

export function merge(state, item) {
  const arr = Array.isArray(item) ? item : [item];
  return state
    .mergeIn(['items'], fromJS(arr.reduce((obj, i) => ({ ...obj, [`${i.location.type}_${i.location.id}_${i.articleId}`]: i }), {})))
    .update('items', v => v.filter(i => i.get('count') !== 0));
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case 'STOCK_SET':
      return merge(state, action.payload);

    case 'STOCK_REMOVE':
      return state.removeIn(['items', action.payload]);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/stock.js